<ng-container *ngIf="getDashboard$ | async as visits">
  <h3>Mis visitas</h3>
  <div class="title">
    <span class="icon-History"></span>
    <span class="subtitule-bay-2">Próximas visitas</span>
  </div>

  <div *ngIf="!visits.upcomingVisits?.length" class="empty-visits body-light-2">
    No hay visitas disponibles
  </div>

  <div
    class="upcoming-visits"
    [ngClass]="{ 'horizontal-carousel': visits.upcomingVisits?.length < 15 }"
  >
    <div
      class="visit-card"
      [ngClass]="{ 'horizontal-carousel': visits.upcomingVisits?.length < 15 }"
      *ngFor="let visit of visits.upcomingVisits"
    >
      <img class="visit-card__image" [src]="visit.mainImage" alt="" />
      <div class="visit-card__content">
        <p class="subtitule-2">{{ visit.property.name }}</p>
        <p class="body-2">{{ visit.visitDateTime }}</p>
        <div class="visit-card__actions">
          <span
            class="icon-Call-Add"
            (click)="openInvitationModal(visit.id)"
          ></span>
          <div
            class="subtitule-2 detail"
            (click)="goToDetail(visit.id, 'upcoming')"
          >
            Detalles
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="title" *ngIf="visits.history?.length">
    <span class="icon-History"></span>
    <span class="subtitule-bay-2">Historial de visitas </span>
  </div>

  <div
    class="history"
    [ngClass]="{ 'horizontal-carousel': visits.history?.length < 15 }"
  >
    <div
      class="visit-card"
      [ngClass]="{ 'horizontal-carousel': visits.history?.length < 15 }"
      *ngFor="let visit of visits.history"
    >
      <img class="visit-card__image" [src]="visit.mainImage" alt="" />
      <div class="visit-card__content">
        <p class="subtitule-2">{{ visit.property.name }}</p>
        <p class="body-2">{{ visit.visitDateTime }}</p>
        <div class="visit-card__actions">
          <div
            class="subtitule-2 detail"
            (click)="goToDetail(visit.id, 'history')"
          >
            Detalles
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
